import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserComponent } from './user.component';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { BillModule } from '../bill/bill.module';
import { MatFormFieldModule, MatInputModule, MatAutocompleteModule, MatCheckboxModule } from '@angular/material';

@NgModule({
	declarations: [UserComponent],
	imports: [
		CommonModule,
		BillModule,
		MatFormFieldModule,
		MatCheckboxModule,
		MatAutocompleteModule,
		MatInputModule,
		RouterModule.forChild([
			{
				path: '**',
				component: UserComponent,
				data: SaveStateData
			}
		])
	]
})
export class UserModule {}
